import { render, staticRenderFns } from "./Compose.Breadcrumbs.vue?vue&type=template&id=a1f59e32&scoped=true&"
import script from "./Compose.Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Compose.Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f59e32",
  null
  
)

export default component.exports